import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import axios from 'axios';

import routes from 'app/routes';
import Modal from 'components/ui/Modal';
import Tooltip from 'components/ui/Tooltip';
import closeIcon from 'images/close-icon.svg';
import ProgramInfo from 'components/Admin/Templates/Views/List/ProgramInfo';

export default function CloseAction({ row }) {
  const [showModal, setShowModal] = useState(false);
  const [program, setProgram] = useState(undefined);

  const onClose = () => {
    swal(
      {
        title: '',
        text: 'Do you want to close the program?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          setProgram(undefined);
          setShowModal(true);

          const url = routes.api.programs.close(row.attributes.id);

          axios
            .patch(url)
            .then((response) => {
              setProgram(response.data.data);
            });
        }
      },
    );
  };

  return (
    <>
      <Button
        bsStyle="link"
        onClick={onClose}
        data-tip="Close"
      >
        <img src={closeIcon} alt="close" />
      </Button>

      <Tooltip />

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        header="Close Program"
      >
        {program === undefined ? (
          <div className="mt-5 text-center">
            Please, wait ...
          </div>
        ) : (
          <>
            {program === null ? (
              <div className="mt-5 text-center">
                Program is already closed.
              </div>
            ) : (
              <ProgramInfo programStatus={program} />
            )}
          </>
        )}
      </Modal>
    </>
  );
}

CloseAction.propTypes = {
  row: PropTypes.object.isRequired,
};
